import * as T from './toast.styles'

type ToastDescriptionProps = {
  children: React.ReactNode
  testID?: string
}
export const ToastDescription = (props: ToastDescriptionProps) => {
  const { children, testID } = props

  const descriptionProps = {
    resizing: 'tail',
    numberOfLines: 1,
    'aria-label': children?.toString(),
  }
  return (
    <T.Description {...descriptionProps} testID={testID}>
      {children}
    </T.Description>
  )
}
